import React from 'react';

import { useDialog } from '../common/withDialog';
import ConversationTitleEditForm from "./ConversationTitleEditForm";
import Loading from "../vulcan-core/Loading";
import MetaInfo from "../common/MetaInfo";
import UsersName from "../users/UsersName";
import { defineStyles } from '../hooks/defineStyles';
import { useStyles } from '../hooks/useStyles';

const styles = defineStyles("ConversationDetails", (theme: ThemeType) => ({
  root: {
    marginTop: 16,
    marginBottom: 16,
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  }
}))

// Component for displaying details about currently selected conversation
const ConversationDetails = ({conversation, hideOptions = false}: {
  conversation: ConversationsList,
  hideOptions?: boolean,
}) => {
  const classes = useStyles(styles);
  const { openDialog } = useDialog();
  if (!conversation?.participants?.length) return <Loading />

  const openConversationOptions = () => {
    openDialog({
      name: "ConversationTitleEditForm",
      contents: ({onClose}) => <ConversationTitleEditForm
        onClose={onClose}
        conversation={conversation}
      />
    });
  }

  return (
    <div className={classes.root}>
      <span>
        <MetaInfo>Participants:</MetaInfo>
        {conversation.participants.map((user, i) => <MetaInfo key={user._id}>
          <UsersName key={user._id} user={user}/>
          {/* inserts a comma for all but the last username */}
          { i < (conversation.participants?.length ?? 0) - 1 && ","}
        </MetaInfo>)}
      </span>
      {!hideOptions && <span onClick={openConversationOptions}>
        <MetaInfo button>Conversation Options</MetaInfo>
      </span>}
    </div>
  )
}

export default ConversationDetails;


